import { SxProps, Theme } from "@mui/material";

export const refereeScreenStyles = {
  outerContainer: {
    mt: "20px",
  },
  contentContainer: {
    p: "1rem",
  },
  headerTypography: {
    mb: "20px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  inviteContainer: {
    display: "flex",
    flexDirection: "column",
    mt: "80px",
    mb: "10px",
    alignItems: "center",
    borderRadius: "8px",
  },
  inviteText: {
    fontSize: "14px",
    color: "#000",
    fontWeight: 400,
    textAlign: "center",
  },
  inviteLink: {
    color: "#000",
    textDecoration: "underline",
    fontWeight: 600,
    cursor: "pointer",
  },
  refereeCard: {
    display: "flex",
    height: "140px",
    alignItems: "center",
    p: "8px",
    borderRadius: "8px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    mb: { xs: "20px", sm: "0px" },
    cursor: "pointer",
  },

  refereeCardImage: {
    height: "130px",
    width: "110px",
    borderRadius: "8px",
    objectFit: "cover" as const,
    
  },
  refereeCardContent: {
    pl: "1rem",
  },
  refereeName: {
    fontSize: "17px",
    fontWeight: 600,
  },
  influencerTypeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px",
  },
  influencerTypeText: {},
  workPlace: {
    fontSize: "15px",
    fontWeight: 400,
  },
  regionText: {
    fontSize: "15px",
    fontWeight: 400,
    color: "#656565",
  },
  adminSection:{

  },


  // cards:
  card: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    height: "auto",
    alignItems: "center",
    padding: "8px",
    borderRadius: "8px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  }),
};